import { RootState } from '@redux/store'

export const accountModeSelector = ({ account }: RootState) =>
  account.accountMode

export const isFamilyShareModeSelector = ({ account }: RootState) =>
  account.isFamilyShareMode
